module.exports = __webpack_public_path__ + "img/brown-wooden-center-table-584399NIGHT.e1d772d1.jpg";